import type { ReactNode } from "react";
import { Icon } from "../icons/Icon";
import { Menu, type MenuItem } from "../primitives/Menu";
import { Button } from "../primitives/Button";
import { cx } from "../utils/format";

/** Send, alone or as a split button (the queue-and-chat-column round, 2026-11-03, part five; the founder's fourth screenshot): with menu items
 *  a chevron "More send options" stands right after Send in one group and opens them below (the ticket page's "Save as draft" and "Discard
 *  draft"); without, Send as it was. One component for the reply box (RichComposer) and the prototype's box (Composer). */
export function SendSplit({ menu, alone, children }: { menu?: MenuItem[]; /** no hint beside it: the group keeps to the right edge itself */ alone?: boolean; /** the Send button */ children: ReactNode }) {
  if (!menu?.length) return <>{children}</>;
  return (
    <span className={cx("ob-composer__send-split", alone && "ob-composer__send-split--alone")}>
      {children}
      <Menu align="end" side="bottom" sections={[{ items: menu }]} trigger={<button type="button" className="ob-composer__send-more" aria-label="More send options" title="More send options"><Icon name="chevronDown" size="sm" /></button>} />
    </span>
  );
}

/** A person's saved reply as a card at the thread's end (the queue-and-chat-column round, part five): the AI card's shape on the muted tint
 *  (the words are the person's, never the AI hue), the head ("Your draft · 2 h ago", the exact time on hover), "Files were not kept" when it
 *  applies, the text, and "Edit reply" (R) and "Discard". Only its owner is ever shown it (the page's rule). */
export function SavedReplyCard({ head, title, filesNote, children, onEdit, onDiscard }: { head: string; /** the exact time, on hover */ title?: string; filesNote?: boolean; /** the text, as the thread shows a message */ children: ReactNode; onEdit: () => void; onDiscard: () => void }) {
  return (
    <section className="ob-saved-reply" aria-label="Your draft">
      <div className="ob-saved-reply__head">
        <span className="ob-saved-reply__title" title={title}>{head}</span>
        {filesNote && <span className="ob-saved-reply__files">Files were not kept</span>}
        <span className="ob-saved-reply__tools">
          <Button variant="ghost" size="sm" icon="pen" onClick={onEdit} aria-keyshortcuts="R">Edit reply</Button>
          <Button variant="ghost" size="sm" onClick={onDiscard}>Discard</Button>
        </span>
      </div>
      <div className="ob-message__body ob-saved-reply__body">{children}</div>
    </section>
  );
}
